<template>
    <div id="detail-barang" class="animated fadeIn">
        <b-modal
            id="m-approve-ivn"
            title="Input Approval"
            size="xl"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @show="init"
        >
            <LoadingWidget
                v-if="initStatus != 1"
                :status="initStatus"
                @init="init"
            />
            <div v-else>
                <b-row>
                    <b-col md="6">
                        <div id="delivery-batch" class="font-weight-bold">
                            Kloter Pengiriman
                        </div>
                        {{ $helper.parseDate(originData.delivery_date) }} -
                        Cabang
                        {{ originData.branch }}
                    </b-col>
                    <b-col md="6">
                        <div id="item-status" class="font-weight-bold">
                            Status Barang
                        </div>
                        <b-badge
                            :variant="
                                parseStatusVariant(originData.inventory_status)
                            "
                        >
                            {{ parseStatusName(originData.inventory_status) }}
                        </b-badge>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div>
                            <div id="item-kind" class="font-weight-bold">
                                Jenis Barang
                            </div>
                            {{ originData.item_kind }}
                        </div>
                        <div>
                            <div id="item-brand" class="font-weight-bold mt-3">
                                Merk Barang
                            </div>
                            {{ originData.item_brand }}
                        </div>
                        <div v-if="originData.item_kind_id === 261">
                            <div class="font-weight-bold mt-3">
                                Merk Cap dari PGI
                            </div>
                            {{ originData.pgi_gold_mint_mark || "-" }}
                        </div>
                        <div v-if="originData.item_kind_id !== 251">
                            <div class="font-weight-bold mt-3">
                                Berat Kotor dari PGI
                            </div>
                            {{ originData.pgi_dry_weight || "-" }}gr
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div>
                            <div id="item-invoice" class="font-weight-bold">
                                No. Faktur PGI
                            </div>
                            {{ originData.no_faktur }}
                        </div>
                        <div>
                            <div id="item-type" class="font-weight-bold mt-3">
                                Tipe Barang
                            </div>
                            {{ originData.item_type }}
                        </div>
                        <div v-if="originData.item_kind_id !== 251">
                            <div class="font-weight-bold mt-3">
                                Kadar dari PGI
                            </div>
                            {{ originData.pgi_purity || "-" }}
                        </div>
                        <div v-if="originData.item_kind_id !== 251">
                            <div class="font-weight-bold mt-3">
                                Berat Potongan dari PGI
                            </div>
                            {{ originData.pgi_weight_reduction || "-" }}gr
                        </div>
                        <div class="d-flex flex-column w-25 mt-3">
                            <strong>Status Temuan</strong>
                            <h6>
                                <b-badge
                                    :variant="
                                        getStatusBadge(varianceData.status)[0]
                                    "
                                    class="text-center"
                                >
                                    {{ getStatusBadge(varianceData.status)[1] }}
                                </b-badge>
                            </h6>
                        </div>
                    </b-col>
                </b-row>
                <hr v-if="goldResetRequest" />
                <b-row v-if="goldResetRequest" class="mt-3">
                    <b-col md="12">
                        <div class="font-weight-bold mb-2">Request Edit Barang</div>
                        <b-row>
                            <b-col md="6">
                                <div class="font-weight-bold">Jenis Baru</div>
                                {{ goldResetRequest.item_kind || "-" }}
                                <div class="font-weight-bold mt-3">Merk Baru</div>
                                {{ goldResetRequest.item_brand || "-" }}
                                <div class="font-weight-bold mt-3">Tipe Baru</div>
                                {{ goldResetRequest.item_type || "-" }}
                                <div v-if="goldResetRequest.gold_type" class="font-weight-bold mt-3">Tipe Emas</div>
                                <div v-if="goldResetRequest.gold_type">{{ goldResetRequest.gold_type }}</div>
                            </b-col>
                            <b-col md="6">
                                <div v-if="goldResetRequest.gold_mint_mark" class="font-weight-bold">Merk Cap Emas</div>
                                <div v-if="goldResetRequest.gold_mint_mark">{{ goldResetRequest.gold_mint_mark }}</div>
                                <div v-if="goldResetRequest.piece_count" class="font-weight-bold mt-3">Jumlah Keping</div>
                                <div v-if="goldResetRequest.piece_count">{{ goldResetRequest.piece_count }} pcs</div>
                                <div v-if="goldResetRequest.has_mark !== null" class="font-weight-bold mt-3">Ada Cap</div>
                                <div v-if="goldResetRequest.has_mark !== null">{{ goldResetRequest.has_mark ? "Ada" : "Tidak Ada" }}</div>
                                <div v-if="goldResetRequest.is_stamped !== null" class="font-weight-bold mt-3">Cap Getok</div>
                                <div v-if="goldResetRequest.is_stamped !== null">{{ goldResetRequest.is_stamped ? "Ada" : "Tidak Ada" }}</div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr />
                <div v-if="originData.inventory_status == 1">
                    <div class="mb-3" v-if="!itemFlags.isLMScan">
                        <b-row>
                            <b-col md="6">
                                <div v-if="isReceiptVariance">
                                    <b-form-group
                                        label="Kadar XRF"
                                        class="font-weight-bold"
                                    >
                                        <b-form-input
                                            :value="varianceData.final_purity"
                                            readonly
                                        />
                                    </b-form-group>
                                </div>
                                <div>
                                    <b-form-group
                                        :label="isReceiptVariance ? 'Kadar Jual' : 'Kadar'"
                                        class="font-weight-bold"
                                    >
                                        <b-form-input
                                            v-model="input.purity"
                                            readonly
                                            :tabindex="1"
                                        />
                                    </b-form-group>
                                </div>
                                <div style="margin-top: 38px;">
                                    <b-form-group
                                        label="Berat Potongan"
                                        class="font-weight-bold"
                                    >
                                        <b-input-group append="gr">
                                            <b-form-input
                                                v-model="input.weightReduction"
                                                readonly
                                                :tabindex="3"
                                            />
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div v-if="itemFlags.isPerhiasan">
                                    <b-form-group
                                        label="Merk Cap Emas"
                                        class="font-weight-bold"
                                    >
                                        <multiselect
                                            class="font-weight-normal"
                                            v-model="input.goldMintMark"
                                            :allow-empty="false"
                                            label="name"
                                            track-by="id"
                                            :internal-search="true"
                                            placeholder="-- Pilih Salah Satu --"
                                            :options="optGoldMintMarks"
                                            :tabindex="5"
                                        />
                                    </b-form-group>
                                </div>
                                <div v-if="!itemFlags.isLMRetro">
                                    <b-form-group
                                        label="Jumlah Keping"
                                        class="font-weight-bold"
                                    >
                                        <b-input-group append="pcs">
                                            <b-form-input
                                                v-model="input.pieceCount"
                                                placeholder="Masukkan jumlah keping"
                                                :tabindex="7"
                                            />
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <div>
                                    <b-form-group
                                        label="Berat Kotor"
                                        class="font-weight-bold"
                                    >
                                        <b-input-group append="gr">
                                            <b-form-input
                                                v-model="input.dryWeight"
                                                readonly
                                                :tabindex="2"
                                            />
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div v-if="itemFlags.isPerhiasan">
                                    <b-form-group
                                        label="Ada Cap"
                                        class="font-weight-bold"
                                    >
                                        <multiselect
                                            class="font-weight-normal"
                                            v-model="input.hasMark"
                                            label="name"
                                            :options="optBoolean"
                                            placeholder="-- Pilih Salah Satu --"
                                            :tabindex="4"
                                        />
                                    </b-form-group>
                                </div>
                                <div
                                    style="margin-top: 38px;"
                                    v-if="itemFlags.isPerhiasan"
                                >
                                    <b-form-group
                                        label="Tipe Emas"
                                        class="font-weight-bold"
                                    >
                                        <multiselect
                                            class="font-weight-normal"
                                            v-model="input.goldType"
                                            :allow-empty="false"
                                            label="name"
                                            track-by="id"
                                            :internal-search="true"
                                            placeholder="-- Pilih Salah Satu --"
                                            :options="optGoldTypes"
                                            :tabindex="6"
                                        />
                                    </b-form-group>
                                </div>
                                <div v-if="itemFlags.isPerhiasan">
                                    <b-form-group
                                        label="Cap Getok"
                                        class="font-weight-bold"
                                    >
                                        <multiselect
                                            class="font-weight-normal"
                                            v-model="input.isStamped"
                                            label="name"
                                            :options="optBoolean"
                                            placeholder="-- Pilih Salah Satu --"
                                            :tabindex="4"
                                        />
                                    </b-form-group>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col md="12" class="text-right">
                            <b-button
                                id="btn-approve-item"
                                variant="success"
                                :disabled="isSubmitting"
                                @click="promptSubmit"
                            >
                                {{
                                    isSubmitting
                                        ? "Menyimpan..."
                                        : "Approve Barang"
                                }}
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <!-- APPROVED, LAINNYA -->
                    <h5 class="mb-0">Input Data Barang</h5>
                    <div class="text-muted">
                        Approval dilakukan oleh
                        <span class="font-weight-bold">{{
                            item.approved_by
                        }}</span>
                        pada {{ $helper.parseDate(item.approved_at) }},
                        {{ $helper.parseHourMinute(item.approved_at) }} WIB
                    </div>
                    <b-row class="mt-3">
                        <b-col md="6">
                            <div class="font-weight-bold">Grade</div>
                            {{ item.grade }}
                            <div class="font-weight-bold mt-3">Kelengkapan</div>
                            {{
                                item.is_batangan == true
                                    ? "Batangan"
                                    : "Lengkap"
                            }}
                            <div class="font-weight-bold mt-3">Spek</div>
                            {{ item.spec }}
                            <div class="font-weight-bold mt-3">
                                Lokasi Penyimpanan
                            </div>
                            {{ item.warehouse || "-" }}
                        </b-col>
                        <b-col md="6">
                            <div class="font-weight-bold">
                                Aksesoris yang Tidak Ada
                            </div>
                            {{ item.missing_accessories || "-" }}
                            <div class="font-weight-bold mt-3">
                                Aksesoris yang Tidak Ori
                            </div>
                            {{ item.not_ori_accessories || "-" }}
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="m-change"
            title="Pengubahan Barang"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <div v-if="isFetching">Mengambil data, mohon menunggu...</div>
            <div v-else>
                <b-form-group id="form-change-kind" label="Jenis Barang">
                    <div id="form-change-kind-select">
                        <multiselect
                            v-model="change.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :options="optChangeKind"
                        />
                    </div>
                </b-form-group>
                <b-form-group id="form-change-brand" label="Merk Barang">
                    <div id="form-change-brand-select">
                        <multiselect
                            v-model="change.brand"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :options="optChangeBrand"
                        />
                    </div>
                </b-form-group>
                <b-form-group id="form-change-type" label="Tipe Barang">
                    <div id="form-change-type-select">
                        <multiselect
                            v-model="change.type"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :options="optChangeType"
                            placeholder="Pilih tipe barang..."
                        />
                    </div>
                </b-form-group>
                <div class="text-right mt-4">
                    <b-button
                        id="btn-save-change"
                        variant="primary"
                        :disabled="isSubmitting"
                        @click="promptChange"
                    >
                        {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="m-barcode"
            title="Cetak Barcode"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak
            dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe
                id="barcode-frame"
                :src="getBarcodeLink()"
                height="300px"
                width="100%"
            />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button
                            id="btn-finish-approval"
                            variant="primary"
                            @click="finishApproval"
                        >
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "modal-approve-ivn",
    props: {
        item: {
            type: Object,
            default: () => null
        },
        action: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isFetching: false,
            firstLoad: false,

            // item: {},
            input: {
                purity: null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: null,
                hasMark: null,
                isStamped: null
            },

            change: {
                kind: {},
                brand: {},
                type: {},
                year: {},
                imeiSn: "",
                password: ""
            },

            // noteLost: "",

            optChangeKind: [],
            optChangeBrand: [],
            optChangeType: [],
            optGoldMintMarks: [],
            optGoldTypes: [],
            optBoolean: [
                { value: true, name: "Ada" },
                { value: false, name: "Tidak Ada" }
            ],
            barcodeLink: "",
            kinds: [],
            brands: [],
            types: []
        };
    },
    watch: {
        "change.kind": function(newVal, oldVal) {
            let isSame =
                newVal != null && oldVal != null && newVal.id == oldVal.id;
            if (this.firstLoad || newVal == null || isSame) {
                return;
            }

            this.change.brand = null;
            this.change.type = null;
            this.change.year = 0;
            this.optChangeBrand = [];
            this.optChangeType = [];

            this.getBrandsByKind(newVal.id)
                .then(data => {
                    this.optChangeBrand = data;
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        "change.brand": function(newVal, oldVal) {
            let isSame =
                newVal != null && oldVal != null && newVal.id == oldVal.id;
            if (this.firstLoad || newVal == null || isSame) {
                return;
            }

            this.change.type = null;
            this.change.year = 0;
            this.optChangeType = [];

            this.getTypesByBrand(newVal.id)
                .then(data => {
                    this.optChangeType = data;
                })
                .catch(error => this.$helper.parseError(this, error));
        }
    },
    methods: {
        async init() {
            this.initStatus = 0;

            await Promise.all([
                this.fetchJenisBarang(),
                this.fetchGoldMintMark(),
                this.fetchGoldType()
            ]);

            if (this.item) {
                await this.prefillForm();
            }

            this.initStatus = 1;
        },

        async prefillForm() {
            // Reset request carries the NEW perhiasan fields; prefer them over origin's.
            const origin = { ...(this.item.origin_item || {}) };
            const reset = this.item.reset_request_item || {};
            [
                "gold_type",
                "gold_mint_mark",
                "piece_count",
                "has_mark",
                "is_stamped"
            ].forEach(key => {
                if (reset[key] !== undefined && reset[key] !== null) {
                    origin[key] = reset[key];
                }
            });
            const variance = this.item.variance || {};

            if (origin.item_kind) {
                const kind = this.kinds.find(k => k.name === origin.item_kind);
                if (kind) {
                    this.input.kind = kind;
                    await this.fetchMerkBarang();
                }
            }

            if (this.input.kind && origin.item_brand) {
                const brand = this.brands.find(
                    b => b.name === origin.item_brand
                );
                if (brand) {
                    this.input.brand = brand;
                    await this.fetchTipeBarang();
                }
            }

            if (this.input.brand && origin.item_type) {
                const type = this.types.find(t => t.name === origin.item_type);
                if (type) {
                    this.input.type = type;
                }
            }

            if (origin.gold_type) {
                const gType = this.optGoldTypes.find(
                    g => g.name === origin.gold_type
                );
                if (gType) this.input.goldType = gType;
            }

            if (
                variance.final_purity !== null &&
                variance.final_purity !== undefined
            ) {
                this.input.purity = variance.final_purity;
            } else {
                this.input.purity = origin.purity;
            }

            if (variance.final_dry_weight != null) {
                this.input.dryWeight = variance.final_dry_weight;
            }

            if (variance.final_weight_reduction != null) {
                this.input.weightReduction = variance.final_weight_reduction;
            }

            // Map Jewelry specific fields
            if (origin.has_mark !== undefined && origin.has_mark !== null) {
                this.input.hasMark = this.optBoolean.find(
                    o => o.value === origin.has_mark
                );
            }

            if (origin.is_damaged !== undefined && origin.is_damaged !== null) {
                this.input.isDamaged = this.optBoolean.find(
                    o => o.value === origin.is_damaged
                );
            }

            if (origin.is_stamped !== undefined && origin.is_stamped !== null) {
                this.input.isStamped = this.optBoolean.find(
                    o => o.value === origin.is_stamped
                );
            }

            if (origin.piece_count) {
                this.input.pieceCount = origin.piece_count;
            }

            if (origin.gold_mint_mark) {
                const mintMark = this.optGoldMintMarks.find(
                    m => m.name === origin.gold_mint_mark
                );
                if (mintMark) this.input.goldMintMark = mintMark;
            }
        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`;
        },

        promptSubmit() {
            const modes = {
                LMScan: [], // no need validation for LMScan
                LMRetro: [{ key: "purity", msg: "Kadar tidak boleh kosong" }],
                Perhiasan: [
                    { key: "purity", msg: "Kadar tidak boleh kosong" },
                    { key: "hasMark", msg: "Status Cap Tanda harus dipilih" },
                    {
                        key: "goldMintMark",
                        msg: "Merk Cap Emas tidak boleh kosong"
                    },
                    { key: "goldType", msg: "Tipe Emas tidak boleh kosong" },
                    {
                        key: "pieceCount",
                        msg: "Jumlah Keping tidak boleh kosong"
                    },
                    { key: "isStamped", msg: "Cap Getok harus dipilih" }
                ]
            };

            const isValidValue = val => val !== null && val !== "";

            let ruleSet = null;
            if (this.itemFlags.isLMScan) ruleSet = modes.LMScan;
            else if (this.itemFlags.isLMRetro) ruleSet = modes.LMRetro;
            else if (this.itemFlags.isPerhiasan) ruleSet = modes.Perhiasan;

            if (ruleSet) {
                for (const { key, msg } of ruleSet) {
                    const val = this.input[key];
                    if (!isValidValue(val)) {
                        this.$helper.toastError(this, msg);
                        return;
                    }
                }
            } else {
                this.$helper.toastError(this, "Tipe Barang tidak valid");
                return;
            }

            if (
                isValidValue(this.input.purity) &&
                (this.input.purity < 1 || this.input.purity > 1000)
            ) {
                this.$helper.toastError(
                    this,
                    "Kadar harus berada di antara 1 dan 1000"
                );
                return;
            }

            if (
                this.isReceiptVariance &&
                isValidValue(this.varianceData.final_purity) &&
                Number(this.input.purity) < Number(this.varianceData.final_purity)
            ) {
                this.$helper.toastError(
                    this,
                    "Kadar Jual tidak boleh lebih rendah dari Kadar XRF"
                );
                return;
            }

            const finalDryWeight = isValidValue(this.input.dryWeight)
                ? this.input.dryWeight
                : this.item.pgi_dry_weight;

            if (!finalDryWeight && !this.itemFlags.isLMScan) {
                this.$helper.toastError(this, "Berat kotor tidak boleh kosong");
                return;
            }

            const finalWeightReduction = isValidValue(
                this.input.weightReduction
            )
                ? this.input.weightReduction
                : this.item.pgi_weight_reduction;

            if (!finalWeightReduction && !this.itemFlags.isLMScan) {
                this.$helper.toastError(
                    this,
                    "Berat potongan tidak boleh kosong"
                );
                return;
            }

            let confirmable = true;

            if (confirmable) {
                let confirmed = confirm(
                    "Lakukan approval dengan data input ini?"
                );
                if (confirmed) {
                    const payload = {
                        id: this.item.variance.origin_id,
                        action: "complete",
                        purity: this.input.purity,
                        dry_weight: this.input.dryWeight
                            ? this.input.dryWeight
                            : this.item.pgi_dry_weight,
                        weight_reduction: this.input.weightReduction
                            ? this.input.weightReduction
                            : this.item.pgi_weight_reduction,
                        gold_mint_mark_id:
                            this.input.goldMintMark != null
                                ? this.input.goldMintMark.id
                                : null,
                        gold_type_id:
                            this.input.goldType != null
                                ? this.input.goldType.id
                                : null,
                        piece_count: this.input.pieceCount,
                        has_mark: this.input.hasMark
                            ? this.input.hasMark.value
                            : null,
                        is_stamped: this.input.isStamped
                            ? this.input.isStamped.value
                            : null
                    };
                    if (this.isReceiptVariance) {
                        payload.purity_xrf = this.varianceData.final_purity;
                    }

                    this.isSubmitting = true;
                    this.$axios
                        .post(
                            "gold-receipt-variances/" +
                                this.item.id +
                                "/approve",
                            payload
                        )
                        .then(res => {
                            this.barcodeLink = res.data.data.link;
                            this.$bvModal.show("m-barcode");
                        })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => (this.isSubmitting = false));
                }
            }
        },

        finishApproval() {
            this.$bvModal.hide("m-barcode");
            this.$emit("refresh");
            this.$bvModal.hide("m-approve-ivn");
        },

        prepareChange() {
            this.$bvModal.show("m-change");

            this.isFetching = true;
            this.$axios
                .get("delivery/request-change/" + this.item.variance.origin_id)
                .then(async res => {
                    let data = res.data.data;

                    this.firstLoad = true;
                    this.change.kind = {
                        id: data.id_kind,
                        name: data.name_kind
                    };
                    this.change.type = {
                        id: data.id,
                        name: data.name,
                        has_year: data.year != null
                    };

                    this.change.brand = {
                        id: data.id_brand,
                        name: data.name_brand
                    };

                    this.change.year = data.year;
                    this.change.imeiSn = data.imei_sn;
                    this.change.password = data.password;

                    this.optChangeKind = data.opt_kind;

                    try {
                        const [brands, types] = await Promise.all([
                            this.getBrandsByKind(data.id_kind),
                            this.getTypesByBrand(data.id_brand)
                        ]);
                        this.optChangeBrand = brands;
                        this.optChangeType = types;
                    } catch (err) {
                        this.optChangeBrand = data.opt_brand || [];
                        this.optChangeType = data.opt_type || [];
                    }

                    this.$nextTick(() => (this.firstLoad = false));
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isFetching = false));
        },

        promptChange() {
            if (
                this.change.kind == null ||
                this.change.brand == null ||
                this.change.type == null
            ) {
                return this.$helper.toastError(
                    this,
                    "Mohon memilih jenis, merk, dan tipe barang!"
                );
            }
            if (this.change.type.has_year == true && this.change.year == 0) {
                return this.$helper.toastError(
                    this,
                    "Mohon memilih tahun / generasi!"
                );
            }

            let isConfirmed = confirm(
                "Lakukan perubahan barang sesuai dengan data ini?"
            );
            if (isConfirmed) {
                let payload = {
                    id: this.item.variance.origin_id,
                    kindId: this.change.kind.id,
                    brandId: this.change.brand.id,
                    typeId: this.change.type.id,
                    year: this.change.type.has_year ? this.change.year : null,
                    imeiSn: this.change.imeiSn,
                    password: this.change.password
                };

                this.isSubmitting = true;
                this.$axios
                    .post("delivery/change", payload)
                    .then(res => {
                        let data = res.data.data;
                        this.item.kind = data.kind;
                        this.item.type = data.type;
                        this.item.year = data.year;
                        this.item.brand = data.brand;
                        this.item.password = data.password;
                        this.item.imei_sn = data.imeiSn;

                        this.$helper.toastSuccess(
                            this,
                            "Data barang berhasil diubah!"
                        );
                        this.$emit("refresh");
                        this.$bvModal.hide("m-change");

                        this.init();
                    })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => (this.isSubmitting = false));
            }
        },

        parseStatusVariant(status) {
            switch (status) {
                case 1:
                    return "warning";
                case 2:
                    return "success";
                case 5:
                    return "danger";
                default:
                    return "light";
            }
        },

        parseStatusName(status) {
            switch (status) {
                case 1:
                    return "PENDING";
                case 2:
                    return "APPROVED";
                case 5:
                    return "HILANG";
                default:
                    return "LAINNYA";
            }
        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            item.adjustment = res;
        },

        async getBrandsByKind(kindId) {
            const res = await this.$axios.get("master/brands/" + kindId);
            return res.data.data;
        },

        async getTypesByBrand(brandId) {
            const res = await this.$axios.get("master/types/" + brandId);
            return res.data.data;
        },

        async fetchJenisBarang() {
            await this.$axios.get("master/kinds?category=EMAS").then(res => {
                this.kinds = res.data.data.filter(
                    item => item.id != 246 && item.id != 252
                );
            });
        },

        async fetchMerkBarang() {
            if (!this.input.kind) return;
            await this.$axios
                .get(`master/brands/${this.input.kind.id}`)
                .then(res => {
                    this.brands = res.data.data;
                });
        },

        async fetchTipeBarang() {
            if (!this.input.brand) return;
            await this.$axios
                .get(`master/types/${this.input.brand.id}`)
                .then(res => {
                    this.types = res.data.data;
                });
        },

        async fetchGoldMintMark() {
            await this.$axios.get("master/gold-mint-mark").then(res => {
                this.optGoldMintMarks = res.data.data;
            });
        },

        async fetchGoldType() {
            await this.$axios.get("master/gold-type").then(res => {
                this.optGoldTypes = res.data.data;
            });
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["warning", "PENDING"];
                case 1:
                    return ["success", "APPROVED"];
                case 2:
                    return ["secondary", "PENDING AUDIT"];
                case 3:
                    return ["primary", "APPROVED AUDIT"];
                case 99:
                    return ["danger", "VARIANCE"];
                default:
                    return ["light", "-"];
            }
        }
    },
    computed: {
        originData() {
            return this.item && this.item.origin_item ? this.item.origin_item : {};
        },
        varianceData() {
            return this.item && this.item.variance ? this.item.variance : {};
        },
        goldResetRequest() {
            return this.item && this.item.reset_request_item
                ? this.item.reset_request_item
                : null;
        },
        itemFlags() {
            // Reset request means the item is approved as the NEW kind.
            const kindId = this.goldResetRequest
                ? this.goldResetRequest.item_kind_id
                : this.originData.item_kind_id;
            return {
                isLMRetro: kindId === 261,
                isLMScan: kindId === 251,
                isPerhiasan: kindId === 257
            };
        },
        // Strict null: an older API without the field must keep the Edit Emas flow.
        // BE maps final_purity -> purity_xrf only for PGI/SGP receipts.
        isReceiptVariance() {
            return this.originData.first_approved_at === null
                && ["PGI", "SGP"].includes(this.originData.source)
                && !this.itemFlags.isLMScan;
        }
    }
};
</script>

<style scoped></style>
